import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { branchCategoryListModel } from "common/models/page-models/custom-model/branchCategory.model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../base-data-services/data.service";

@Injectable()
export class branchCategoryListDataService extends DataService<branchCategoryListModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.getBranchCategoryList,http);
    }


//    override getAPI_URL(): API_URL {
//         return API_URL.getDocumentTypeList;
//       }
    
    createInstance():branchCategoryListModel  {
        return new branchCategoryListModel();
    }

}